var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParcelDetailsGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.683 25.0541L6 19.5717V8.0166L15.683 13.4147V25.0541Z",
    fill: "#B7B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.407 25.0541L26.0001 19.5717V8.0166L16.407 13.4147V25.0541Z",
    fill: "#B7B8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4645 9.91413L25.9994 7.41181L15.9997 2L11.6765 4.33969L21.4645 9.91413Z",
    fill: "#B7B8B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2316 4.58032L6 7.41179L15.9997 12.9294L21.0237 10.1574L11.2316 4.58032Z",
    fill: "#B7B8B8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelDetailsGrey);
export default __webpack_public_path__ + "static/media/parcel-details-grey.8ceea629b3cf0c576f0ae6f1b238c6be.svg";
export { ForwardRef as ReactComponent };